import { ActiveLensSubscription } from "./ActiveLensSubscription";
import { planMetadata } from "src/services/plans";
import { PersonalBilling } from "./PersonalBilling";

export function PersonalSubscription() {
  return (
    <ActiveLensSubscription
      licenseType="personal"
      features={planMetadata.personal.features}
      billing={<PersonalBilling />}
    />
  );
}
